<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  data (){
    return {
      showRouter: true
    }
  },
  created() {
    this.getRem(1600 , 100);
    window.onresize = () => {
      this.getRem(1600, 100);
    };
  },
  methods: {
    // 设置根大小，元素宽高字体大小都可以用rem,10px = 0.1rem
    getRem(pwidth, prem) {
      var html = document.getElementsByTagName("html")[0];
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
    },
  },
  mounted() {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue